/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { UserAccountDto } from './user-account-dto';

/**
 * 
 * @export
 * @interface PrescriptionRequestSummaryDto
 */
export interface PrescriptionRequestSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof PrescriptionRequestSummaryDto
     */
    'dueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionRequestSummaryDto
     */
    'entryDate'?: string;
    /**
     * 
     * @type {UserAccountDto}
     * @memberof PrescriptionRequestSummaryDto
     */
    'fromUser'?: UserAccountDto;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionRequestSummaryDto
     */
    'outcomeDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionRequestSummaryDto
     */
    'outcomeReason'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrescriptionRequestSummaryDto
     */
    'requestId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrescriptionRequestSummaryDto
     */
    'status'?: PrescriptionRequestSummaryDtoStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PrescriptionRequestSummaryDtoStatusEnum {
    New = 'NEW',
    Accepted = 'ACCEPTED',
    Done = 'DONE',
    Rejected = 'REJECTED',
    Cancelled = 'CANCELLED',
    Forwarded = 'FORWARDED'
}


